module.exports = __webpack_public_path__ + "static/media/list-noactive.fb59265f.svg";